import React from 'react';
import { styled } from 'styled-components';

interface ProgressBarProps {
  percentage: number; // 0-100
  width?: string | number;
  height?: string | number;
  borderRadius?: string | number;
  showTransition?: boolean;
  marginBottom?: string | number;
  className?: string;
}

export const ProgressBar: React.FC<ProgressBarProps> = ({
  percentage,
  width = '100%',
  height = 6,
  borderRadius = 999,
  showTransition = true,
  marginBottom,
  className
}) => {
  // percentage를 0-100 범위로 제한
  const clampedPercentage = Math.min(Math.max(percentage, 0), 100);

  return (
    <ProgressContainer 
      $width={width}
      $height={height}
      $borderRadius={borderRadius}
      $marginBottom={marginBottom}
      className={className}
    >
      <ProgressFill 
        $percentage={clampedPercentage}
        $borderRadius={borderRadius}
        $showTransition={showTransition}
      />
    </ProgressContainer>
  );
};

const ProgressContainer = styled.div<{
  $width: string | number;
  $height: string | number;
  $backgroundColor?: string;
  $borderRadius: string | number;
  $marginBottom?: string | number;
}>`
  width: ${({ $width }) => typeof $width === 'number' ? `${$width}px` : $width};
  height: ${({ $height }) => typeof $height === 'number' ? `${$height}px` : $height};
  background: ${({ theme }) => theme.colors.bgGray[600]};
  border-radius: ${({ $borderRadius }) => typeof $borderRadius === 'number' ? `${$borderRadius}px` : $borderRadius};
  overflow: hidden;
  margin-bottom: ${({ $marginBottom }) => $marginBottom ? (typeof $marginBottom === 'number' ? `${$marginBottom}px` : $marginBottom) : 0};
  flex-shrink: 0;
`;

const ProgressFill = styled.div<{
  $percentage: number;
  $borderRadius: string | number;
  $showTransition: boolean;
}>`
  width: ${({ $percentage }) => $percentage}%;
  height: 100%;
  background: ${({ theme }) => theme.colors.primary};
  border-radius: ${({ $borderRadius }) => typeof $borderRadius === 'number' ? `${$borderRadius}px` : $borderRadius};
  transition: ${({ $showTransition }) => $showTransition ? 'width 0.3s ease' : 'none'};
`;